import qs from 'qs'
import { WEBVIEW_TYPES, LOCAL_STORAGE_KEYS } from '@/lib/consts.ts'

export function detectWebView () {
  const params = qs.parse(window.location.search.substring(1))

  if (params.isIOS === '1') {
    localStorage.setItem(LOCAL_STORAGE_KEYS.APP_WEB_VIEW, WEBVIEW_TYPES.IOS)
    return
  }

  if (params.isAndroid === '1') {
    localStorage.setItem(LOCAL_STORAGE_KEYS.APP_WEB_VIEW, WEBVIEW_TYPES.ANDROID)
    return
  }

  if (params.isWWW === '1') {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.APP_WEB_VIEW)
  }
}
